import { render } from "./AvisoPrivacidade.vue?vue&type=template&id=fbbc12ec&scoped=true"
import script from "./AvisoPrivacidade.vue?vue&type=script&lang=js"
export * from "./AvisoPrivacidade.vue?vue&type=script&lang=js"

import "./AvisoPrivacidade.vue?vue&type=style&index=0&id=fbbc12ec&scoped=true&lang=css"

import exportComponent from "/var/www/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbc12ec"]])

export default __exports__